module.exports = __webpack_public_path__ + "static/assets/94c22a1ec83c661385c925912a546e10.png";